import imageProject from './img/Fig1.jpg'
import imagePlan from './img/plan.jpg'
import imageInquiry from './img/inquiry.jpg'
import imageMiro from './img/Fig1a.jpg'
import imageForm from './img/form.jpg'

import context1 from './img/context1.jpg'
import context2 from './img/context2.jpg'
import context3 from './img/context3.jpg'

import ideation0 from './img/home.png'
import ideation1 from './img/pinterest.jpg'
import ideation2 from './img/inspiration_wall.jpg'
import ideation3 from './img/sketching.jpg'

import prototype1 from './img/wireframe1.jpg'
import prototype2 from './img/wireframe2.jpg'
import prototype3 from './img/ios1.jpg'
import prototype4 from './img/ios2.jpg'

import imageDesign from './img/Fig2.jpg'
import imageDesign2 from './img/Fig3-1.jpg'
import imageDesign3 from './img/Fig3-2.jpg'
import imageDesign4 from './img/Fig1b.jpg'

import e1 from './img/e1.jpg'
import e2 from './img/e2.jpg'
import e3 from './img/Fig4.jpg'

import electronics1 from './img/electronics/1.jpg'
import electronics2 from './img/electronics/2.jpg'
import electronics3 from './img/electronics/3.jpg'
import electronics4 from './img/electronics/4.jpg'
import electronics5 from './img/electronics/5.jpg'
import electronics6 from './img/electronics/6.jpg'
import electronics7 from './img/electronics/7.jpg'
import electronics8 from './img/electronics/8.jpg'

import imageMore1 from './img/more/Fig1a.jpg'
import imageMore2 from './img/more/Fig6a.jpg'
import imageMore3 from './img/more/Fig6b.jpg'
import imageMore4 from './img/more/Fig6c.jpg'
import imageMore5 from './img/more/Fig7.jpg'
import imageMore6 from './img/more/Fig1c.jpg'
import imageMore7 from './img/more/Fig5a.jpg'
import imageMore8 from './img/more/Fig5b.jpg'
import imageMore9 from './img/more/Fig5c.jpg'
import imageMore10 from './img/more/Fig5d.jpg'

const images = {

  singles: {
    imageProject:    { src: imageProject, alt: 'PhotoClock Design' },
    imagePlan:       { src: imagePlan, alt: 'PhotoClock Design' },
    imageInquiry:    { src: imageInquiry, alt: 'PhotoClock Use Scenario' },
    imageMiro:       { src: imageMiro, alt: 'PhotoClock Use Scenario' },
    form:            { src: imageForm, alt: 'PhotoClock Use Scenario' },
    e1:            { src: e1, alt: 'PhotoClock Use Scenario' },
    e2:            { src: e2, alt: 'PhotoClock Use Scenario' },
    e3:            { src: e3, alt: 'PhotoClock Use Scenario' },
    design:       { src: imageDesign, alt: 'PhotoClock Use Scenario' },
  },

  context: [
    { src: context1, alt: 'PhotoClock Design' },
    { src: context2, alt: 'PhotoClock Design' },
    { src: context3, alt: 'PhotoClock Design' },
  ],

  ideation: [
    { src: ideation0, alt: 'PhotoClock Design' },
    { src: ideation1, alt: 'PhotoClock Design' },
    { src: ideation2, alt: 'PhotoClock Design' },
    { src: ideation3, alt: 'PhotoClock Design' },
  ],

  prototype: [
    { src: prototype1, alt: 'PhotoClock Design' },
    { src: prototype2, alt: 'PhotoClock Design' },
    { src: prototype3, alt: 'PhotoClock Design' },
    { src: prototype4, alt: 'PhotoClock Design' },
  ],

  design: [
    { src: imageDesign4, alt: 'PhotoClock Use Scenario' },
    { src: imageDesign2, alt: 'PhotoClock Design' },
    { src: imageDesign3, alt: 'PhotoClock Design' },
  ],

  electronics: [
    { src: electronics1, alt: 'Chronoscope Electronics' },
    { src: electronics2, alt: 'PhotoClock Design' },
    { src: electronics3, alt: 'PhotoClock Design' },
    { src: electronics4, alt: 'PhotoClock Use Scenario' },
    { src: electronics5, alt: 'Chronoscope Electronics' },
    { src: electronics6, alt: 'PhotoClock Design' },
    { src: electronics7, alt: 'PhotoClock Design' },
    { src: electronics8, alt: 'PhotoClock Use Scenario' },
  ],

  more: [
    { src: imageMore1, alt: 'PhotoClock Design' },
    { src: imageMore2, alt: 'PhotoClock Design' },
    { src: imageMore3, alt: 'PhotoClock Design' },
    { src: imageMore4, alt: 'PhotoClock Use Scenario' },
    { src: imageMore5, alt: 'PhotoClock Design' },
    { src: imageMore6, alt: 'PhotoClock Design' },
    { src: imageMore7, alt: 'PhotoClock Design' },
    { src: imageMore8, alt: 'PhotoClock Use Scenario' },
    { src: imageMore9, alt: 'PhotoClock Design' },
    { src: imageMore10, alt: 'PhotoClock Use Scenario' },
  ],
};

export default images;